import { AccountingHolidayPayDebtReportQueryController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the accounting holiday debt report builder for ad hoc reporting queries.
 * @example
 * ```html
 * <salaxy-accounting-holiday-debt-report-query></salaxy-accounting-holiday-debt-report-query>
 * ```
 */
export class AccountingHolidayPayDebtReportQuery extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /**
       * Report view table only (partial) or pdf preview (full)
       * Defaults to 'partial'
       */
      view: "<",
      /** The language for report*/
      lang: "<"
    };

    /** Uses the AccountingReportQueryController */
    public controller = AccountingHolidayPayDebtReportQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/AccountingHolidayPayDebtReportQuery.html";

}
